import { render, staticRenderFns } from "./robo-report.vue?vue&type=template&id=0cbb9670&scoped=true&lang=pug&"
import script from "./robo-report.vue?vue&type=script&lang=js&"
export * from "./robo-report.vue?vue&type=script&lang=js&"
import style0 from "./robo-report.vue?vue&type=style&index=0&id=0cbb9670&scoped=true&lang=scss&"
import style1 from "./robo-report.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbb9670",
  null
  
)

export default component.exports